// extracted by mini-css-extract-plugin
module.exports = {"icons":"_18ehPzh6O1xX","icon":"_3Qy1PQLSTSx9"};